/**
 * Accordion Section Component
 * Collapsible section for grouping related fields
 * Used for: Channel webhook codes, KnowledgeBase business context fields
 */

import React, { useState } from 'react';
import './AccordionSection.css';

export interface AccordionSectionProps {
  title: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
  badge?: string;
  icon?: React.ReactNode;
  onToggle?: (expanded: boolean) => void;
}

export const AccordionSection: React.FC<AccordionSectionProps> = ({
  title,
  defaultExpanded = true,
  children,
  badge,
  icon,
  onToggle,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    const newExpanded = !expanded;
    setExpanded(newExpanded);
    onToggle?.(newExpanded);
  };

  return (
    <div className={`accordion-section ${expanded ? 'expanded' : 'collapsed'}`}>
      <button
        className="accordion-header"
        onClick={handleToggle}
        aria-expanded={expanded}
      >
        <span className="accordion-icon">
          {expanded ? '▼' : '▶'}
        </span>

        <span className="accordion-title">
          {icon && <span className="accordion-badge-icon">{icon}</span>}
          {title}
        </span>

        {badge && <span className="accordion-badge">{badge}</span>}
      </button>

      {expanded && (
        <div className="accordion-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default AccordionSection;
